import React from "react";

/**
 * View toggle component for switching between Card and Table views
 * @param {string} currentView - Current view mode ('cards' or 'table')
 * @param {function} onViewChange - Callback when view changes
 */
const ViewToggle = ({ currentView, onViewChange }) => {
  return (
    <div className="ctf-view-toggle">
      <button
        type="button"
        className={`view-toggle-btn ${
          currentView === "cards" ? "active" : ""
        }`}
        onClick={() => onViewChange("cards")}
      >
        Card View
      </button>
      <button
        type="button"
        className={`view-toggle-btn ${
          currentView === "table" ? "active" : ""
        }`}
        onClick={() => onViewChange("table")}
      >
        Table View
      </button>
    </div>
  );
};

export default ViewToggle;

